<template>
  <div class="footer">
    <div class="w clearfix">
      <a href="http://www.fundoll.jp"
         target="_blank">
        <div class="company_logo"></div>
      </a>
      <span class="agreement_list ">
        <div class="clearfix text1">
          <a target="_blank"
             href="https://jp.catfantasygame.com/privacypolicy.html?agreement_id=59&section=2&title=TermsofService&logo=FUNDOLL">利用規約</a>
          <i></i>
          <a target="_blank"
             href="https://jp.catfantasygame.com/privacypolicy.html?agreement_id=59&section=3&title=PrivacyPolicy&logo=FUNDOLL">プライバシーポリシー</a>
        </div>
        <div class="agreement_list1 text2 clearfix"><a target="_blank"
             href="https://passport-user-center.fundollgame.com/#/agreement?agreement_id=56&section=0&section_id=152">特定商取引法に基づく表示</a>
          <i></i> <a target="_blank"
             href="https://passport-user-center.fundollgame.com/#/agreement?agreement_id=56&section=0&section_id=151">資金決済法に基づく表示</a>
        </div>
        <p style="color: #ccc; margin-top: 5px; font-size: 16px;"> © FUNDOLL GLOBAL LIMITED All rights reserved.</p>
      </span>

    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .footer {
    width: 100%;
    margin-top: 20px;
    padding-bottom: 30px;
    .w {
      width: 100%;
      background: #fff;
      box-sizing: border-box;
      .company_logo {
        width: 2.5rem;
        height: 0.76rem;
        padding-top: 0px;
        background: url('../../../assets/images/mycard/fundoll.png') no-repeat;
        background-size: contain;
        color: #03d7eb;
        margin-top: 25px;
        margin: 0 auto;
      }
      .agreement_list {
        margin-top: 20px;
        text-align: center;
        .text1 {
          width: 240px;
          margin: 0 auto;
          text-align: center;
        }
        .text2 {
          width: 370px;
          margin: 0 auto;
          text-align: center;
        }
        i {
          width: 1px;
          height: 23px;
          display: inline-block;
          background: #03d7eb;
          margin: 0 10px;
          margin-top: 5px;
          float: left;
        }
        a {
          color: #03d7eb;
          font-size: 15px;
          float: left;
        }
      }
    }
  }
}
@media (min-width: 1000px) and (max-width: 3000px) {
  .footer {
    width: 100%;
    margin-top: 20px;
    padding-bottom: 50px;
    .w {
      width: 1000px;
      background: #fff;
      padding: 30px;
      box-sizing: border-box;
      .company_logo {
        width: 250px;
        height: 76px;
        padding-top: 0px;
        background: url('../../../assets/images/mycard/fundoll.png') no-repeat;
        background-size: contain;
        color: #03d7eb;
        margin-top: 25px;
        float: left;
      }
      .agreement_list {
        margin-top: 20px;
        margin-left: 65px;
        float: right;
        i {
          width: 1px;
          height: 23px;
          display: inline-block;
          background: #03d7eb;
          margin: 0 15px;
          margin-top: 5px;
          float: left;
        }
        a {
          color: #03d7eb;
          font-size: 18px;
          float: left;
        }
      }
    }
  }
}
</style>